// 法国语言
export const common = {
  cancel:"Annulation",
  confirm:"Confirmé",
  country:"Pays"
};
// 订单列表页面
export const orderList = {
  title:"Liste des commandes",
};

// 查询页面
export const cardLoop = {
  cardTitle:"Numéro iccid de la carte SIM",
  cardDesc:"Entrez le numéro iccid de la carte SIM dans la zone de saisie.",
  query:"Rechercher", //查询按钮
  title:"Plateforme carte SIM IOT",
};

// 详情页面
export const cardInfo = {
  title:"Informations sur la carte",
  msisdn:"MSISDN：",
  iccid:"ICCID：",
  expiration:"Expiration：",//过期时间
  status:'Statut',
  refresh:"Rafraîchir",//刷新
  residualFlow:"Restant",//剩余流量
  totalFlow:"débitTotal",//总流量
  used:"Utilisé",//已使用
  lists:["Utilisant","Inutilisé","Utilisé"],//tab切换 1 生效中 2 未生效 3.已失效
  validity:"tiempo",//套餐有效期
  skuUsed:"Utilisé",//套餐已用
  skuTotal:"débitTotal",//套餐总量
  recharge:"Recharger",//去充值
};

// 选套餐页面
export const cardPlans = {
  title:"Liste des Packages",
  buyPlan:"Plan d'achat",
  select:"Non séléctionné",//未选套餐的提示
  orderList:"Liste des commandes",
  userAgreement:"Accord utilisateur",
  price:"Prix du forfait",
  flowCount:"Trafic total",
  validityTime:"Date de validité",
  switchCountryName:"Zones utilisables",
  productDesc:"Description du package",
  productDescText:"Paiement anticipé",
  paymentMethod:"Modes de paiement",
  checkUserAgreementMsg:"Veuillez cocher l'accord utilisateur",
  payErrorMsg:"Le compte de collecte ne supporte pas le paiement RMB",
  payBtnText:"Avec",
};


// 完成支付或取消支付
export const cardPayEnd = {
  title:"Résultats des paiements",
  Details:"Détails",//返回详情
};

export const country = {
  America:'États - Unis',
  HongKong:'Hong Kong',
  Thailand:'Thaïlande',
  Philippines:'Philippines',
  Macao:'Macao'
}

// 位置标签
export const placeTitle = "Pays dans lesquels";
// 国家名称
export const China = "Chine"
export const America = "États - Unis"
export const HongKong = "Hong Kong"







